import { createContext, useCallback, useState } from "react";
import { toast } from 'react-toastify';

const UIContext = createContext({});

export const UIContextProvider = ({ children }) => {
  // Snack Bar State
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertType, setAlertType] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  // Progress Loading State
  const [openLoader, setOpenLoader] = useState(false);

  // Loading Handlers
  const showLoading = useCallback(() => {
    setOpenLoader(true);
  }, []);

  const hideLoading = useCallback(() => {
    setOpenLoader(false);
  }, []);

  // SnackBar Handlers
  const openSnackBar = useCallback((message, type = 'success') => {
    setAlertType(type);
    setAlertMessage(message);
    setAlertOpen(true);
  }, []);

  const closeSnackBar = useCallback(() => {
    setAlertMessage('');
    setAlertOpen(false);
  }, []);

  const showToast = useCallback((message, type = 'success') => {
    if (type === 'success') {
      toast.success(message);
    } else {
      toast.error(message);
    }
  }, []);

  const showPromiseToast= useCallback((asyncFunc,pending="Loading...",success="Operation successful 👌",error="Operation failed 🤯") => {
    toast.promise(
      asyncFunc(),
      {
        pending,
        success,
        error,
      },
      {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        draggable: true,
      }
    );
  }, []);


  return (
    <UIContext.Provider
      value={{
        openSnackBar,
        closeSnackBar,
        alertOpen,
        alertType,
        alertMessage,
        showLoading,
        hideLoading,
        openLoader,
        showToast ,
        showPromiseToast
      }}
    >
      {children}
    </UIContext.Provider>
  );
};

export default UIContext;
